import img1 from "../assets/gallery/New Zealand/new-zealand1.jpg";
import img2 from "../assets/gallery/New Zealand/new-zealand2.jpg";
import img3 from "../assets/gallery/New Zealand/new-zealand3.jpg";
import img4 from "../assets/gallery/New Zealand/new-zealand4.jpg";
import img5 from "../assets/gallery/New Zealand/new-zealand5.jpg";
import img6 from "../assets/gallery/New Zealand/new-zealand6.jpg";
import img7 from "../assets/gallery/New Zealand/new-zealand7.jpg";
import img8 from "../assets/gallery/New Zealand/new-zealand8.jpg";
import img9 from "../assets/gallery/New Zealand/new-zealand9.jpg";
import img10 from "../assets/gallery/New Zealand/new-zealand10.jpg";
import img11 from "../assets/gallery/New Zealand/new-zealand11.jpg";
import img12 from "../assets/gallery/New Zealand/new-zealand12.jpg";
import img13 from "../assets/gallery/New Zealand/new-zealand13.jpg";
import img14 from "../assets/gallery/New Zealand/new-zealand14.jpg";
import img15 from "../assets/gallery/New Zealand/new-zealand15.jpg";
import img16 from "../assets/gallery/New Zealand/new-zealand16.jpg";
import img17 from "../assets/gallery/New Zealand/new-zealand17.jpg";
import img18 from "../assets/gallery/New Zealand/new-zealand18.jpg";

const newZealandGallery = [
  { img: img1, rowSpan: 2 },
  { img: img2 },
  { img: img3 },

  { img: img4 },
  { img: img5 },
  { img: img6, rowSpan: 2 },

  { img: img7, colSpan: 2 },

  { img: img8 },
  { img: img9, rowSpan: 2 },
  { img: img10 },

  { img: img11 },
  { img: img12 },
  { img: img13 },

  { img: img14},
  { img: img15 },

  { img: img16, rowSpan: 2 },
  { img: img17 },
  { img: img18 },
];

export default newZealandGallery;
